import * as Migration from 'shared/migration/migration';


const conversions = [
  { version: '1', rules: [{ isSuitable: () => true, migrateUp: v0tov1 }]},
];

export const CURRENT_VERSION = '1';

export function migrateToTheLatest(flows) {
  return Migration.migrateToTheLatest(flows, conversions);
}


function v0tov1(flow) {
  flow.options.flowsteps ??= [];
}
